import { z } from 'zod';

export enum WebappEnv {
  PRODUCTION = 'production',
  STAGING = 'staging',
  SANDBOX = 'sandbox',
  LOCAL = 'local',
}

export const WebappEnvSchema = z.nativeEnum(WebappEnv);
